<template>
  <div class="select-props-container">
    <t-popup
      placement="bottom-left"
      :showArrow="false"
      v-model="show"
      width="330"
      overlayClassName="select-props-popover-container"
      trigger="click"
    >
      <template #content>
        <div class="cont">
          <div class="top">
            <div>
              <t-input
                placeholder="请输入关键字"
                :size="size"
                clearable
                @change="handleSearchWordChange"
                v-model.trim="searchWord"
              >
                <!--<i slot="suffix" class="el-input__icon el-icon-search"></i>-->
              </t-input>
            </div>
            <div class="group" v-show="!showSearch">
              <t-tag
                size="small"
                class="btn"
                v-for="item in optionsCalc"
                :key="item.key"
                :class="{ active: item.name === currentTypeObj.name }"
                @click="handleSelectType(item)"
              >
                {{ item.name }}
              </t-tag>
            </div>
          </div>

          <div class="content" v-show="!showSearch" @scroll="handleScroll" ref="scrollCont" style="position: relative">
            <div class="total" v-if="showTotal" @click="handleSelect(totalItem)">
              <div class="label">{{ totalItem.label }}</div>
              <div class="val"></div>
            </div>
            <div class="group-item" v-for="item in optionsCalc" :key="item.key" :ref="item.key">
              <div class="header">
                <div class="txt">{{ item.name }}</div>
                <div class="line"></div>
              </div>
              <div class="list">
                <div
                  class="list-item"
                  :class="{ 'is-disabled': subItem.isDisabled }"
                  v-for="subItem in item.list"
                  :key="subItem.value"
                  @click="handleSelect(subItem)"
                >
                  <span class="label" :title="subItem.label">{{ subItem.label }}</span>
                  <span class="val" :title="subItem.value">{{ subItem.value }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="content" v-show="showSearch && searchResult.length">
            <div class="group-item" v-for="item in searchResult" :key="item.key">
              <div class="header">
                <div class="txt">{{ item.name }}</div>
                <div class="line"></div>
              </div>
              <div class="list">
                <div
                  class="list-item"
                  :class="{ 'is-disabled': subItem.isDisabled }"
                  v-for="subItem in item.list"
                  :key="subItem.value"
                  @click="handleSelect(subItem)"
                >
                  <span class="label" :title="subItem.label">{{ subItem.label }}</span>
                  <span class="val" :title="subItem.value">{{ subItem.value }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="empty" v-show="showSearch && !searchResult.length">
            <div class="info">
              <div>未找到结果</div>
              <div class="desc">请换个关键词</div>
            </div>
          </div>
        </div>
      </template>

      <t-button variant="outline" :size="size" class="ref-cont" :disabled="disabled">
        <span
          class="text"
          :class="{ empty: !currentObj.value }"
          style="display: inline-block; text-align: left; min-width: 140px"
        >
          {{ currentObj.label || this.placeholder }}
        </span>
        <icon class="icon" :name="!show ? 'chevron-down' : 'chevron-up'" style="margin-left: 6px"></icon>
      </t-button>
    </t-popup>
  </div>
</template>

<script>
import { Icon } from 'tdesign-icons-vue';

export default {
  components: {
    Icon,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'medium',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '请选择',
    },
    showTotal: {
      type: Boolean,
      default: false,
    },
    conditionPropertyOptions: {
      type: Array,
      required: true,
    },
    allEventEventPropertyList: {
      type: Array,
      default: () => [],
    },
    filterEvents: {
      type: String,
      default: '',
    },
    filterPropertyFn: {
      type: Function,
      default: () => true,
    },
  },
  data() {
    return {
      show: false,
      currentTypeObj: {},
      currentObj: { label: this.value, value: this.value },
      totalItem: { label: '总体', value: 'all', isDisabled: false },
      searchWord: '',
      showSearch: false,
      searchResult: [],
      clickScrollFlag: false, // 标识刚点击tab触发的滚动，避免滚动区的滚动导致tab的变化
    };
  },
  computed: {
    optionsCalc() {
      let eventArr = [];
      if (this.filterEvents) {
        eventArr = this.filterEvents.split(',');
      }
      let propertyList = [...this.conditionPropertyOptions];
      if (eventArr.length > 0) {
        const arrArr = eventArr.map(eventName => {
          const findItem = this.allEventEventPropertyList.find(i => i.eventName === eventName);
          return findItem ? findItem.propertyList : [];
        });
        const jiaojiProperList = this.propertyArrJiaoJi(arrArr);
        propertyList = propertyList.filter(item => {
          if (item.propertyType === 1) {
            // 目前只处理事件属性
            if (jiaojiProperList.findIndex(i => i.propertyName === item.propertyName) === -1) {
              return false;
            }
            return true;
          }
          return true;
        });
      }

      return this.makeOptions(propertyList);
    },
  },
  watch: {
    show() {
      if (!this.show) {
        this.searchWord = '';
      }
    },
    searchWord() {
      this.handleSearchWordChange();
    },
    value() {
      this.$nextTick(() => {
        this.setCurrentObj();
      });
    },
    conditionPropertyOptions() {
      this.$nextTick(() => {
        this.setCurrentObj();
      });
    },
    filterEvents() {
      this.$nextTick(() => {
        this.setCurrentObj();
      });
    },
  },
  async created() {
    this.setCurrentObj();
  },
  methods: {
    handleSelect(item) {
      if (item.isDisabled) {
        return;
      }
      this.changeCurrentObj(item);
      this.show = false;
    },
    changeCurrentObj(item) {
      this.currentObj = item;
      this.$emit('input', item.value);
      this.$emit('change', item.value);
    },

    handleScroll() {
      // 如果是顶部tab点击触发的滚动，则不执行后续的逻辑
      if (this.clickScrollFlag) {
        return;
      }
      const { scrollCont } = this.$refs;
      const { scrollTop, offsetHeight } = scrollCont;

      const totalHeight = scrollTop + offsetHeight - 28;
      let currTypeObj;
      for (let i = this.optionsCalc.length - 1; i >= 0; i--) {
        const item = this.optionsCalc[i];
        let el = this.$refs[item.key];
        if (Array.isArray(el)) {
          [el] = el;
        }

        if (totalHeight >= el.offsetTop) {
          currTypeObj = item;
          break;
        }
      }

      if (currTypeObj) {
        this.currentTypeObj = currTypeObj;
      }
    },
    handleSelectType(item) {
      this.currentTypeObj = item;
      let el = this.$refs[item.key];
      if (Array.isArray(el)) {
        [el] = el;
      }
      this.clickScrollFlag = true; // 设置标志位，避免滚动区滚动的计算高亮哪个tab
      setTimeout(() => {
        this.clickScrollFlag = false;
      }, 100);
      const { scrollCont } = this.$refs;
      scrollCont.scrollTop = el.offsetTop;
    },
    handleSearchWordChange() {
      const sw = this.searchWord;
      if (!sw) {
        this.showSearch = false;
        this.searchResult = [];
        return;
      }

      this.showSearch = true;
      const result = [];
      this.optionsCalc.forEach(item => {
        const tmpList = [];
        item.list.forEach(subItem => {
          if (subItem.label.indexOf(sw) !== -1 || subItem.value.indexOf(sw) !== -1) {
            tmpList.push(subItem);
          }
        });
        if (tmpList.length) {
          result.push({
            name: item.name,
            key: item.key,
            list: tmpList,
          });
        }
      });
      this.searchResult = result;
    },

    makeOptions(conditionPropertyOptions) {
      const options = [];
      const dataMap = new Map();
      conditionPropertyOptions.forEach(cpo => {
        const propertyType = cpo.propertyType === undefined ? 1 : cpo.propertyType;
        if (!dataMap.has(propertyType)) {
          dataMap.set(propertyType, []);
        }
        const list = dataMap.get(propertyType);
        list.push({
          label: cpo.propertyDesc,
          value: cpo.propertyName,
          type: propertyType,
          isDisabled: cpo.disabled,
        });
      });

      dataMap.forEach((list, ptype) => {
        options.push({
          type: ptype,
          key: `prop_type_${ptype}`,
          name: this.getPropertyTypeName(ptype),
          list,
        });
      });

      options.sort((a, b) => a.type - b.type);
      return options;
    },

    setCurrentObj() {
      const val = this.value;
      if (val === 'all') {
        // 总体
        this.currentObj = this.totalItem;
        return;
      }
      let tmpCurrentObj;
      this.optionsCalc.forEach(item => {
        item.list.forEach(subItem => {
          if (subItem.value === val) {
            tmpCurrentObj = subItem;
            return false;
          }
          return true;
        });
      });
      if (tmpCurrentObj) {
        this.currentObj = tmpCurrentObj;
      } else {
        // this.changeCurrentObj(this.getFirstPropertyItem());
        // eslint-disable-next-line no-lonely-if
        if (this.showTotal) {
          this.changeCurrentObj(this.totalItem);
        }
      }
    },

    getFirstPropertyItem() {
      if (this.showTotal) {
        return this.totalItem;
      }
      let retItem;
      if (this.optionsCalc.length) {
        const item = this.optionsCalc[0];
        if (item.list.length) {
          retItem = item.list[0];
        }
      }
      return retItem || { label: '', value: '' };
    },

    getPropertyTypeName(propertyType) {
      let pname = '';
      switch (propertyType) {
        case 1:
          pname = '事件属性';
          break;
        case 2:
          pname = '用户属性';
          break;
        case 3:
          pname = '可视化埋点';
          break;
        case 4:
          pname = '用户标签';
          break;
        case 5:
          pname = '虚拟属性';
          break;
        case 6:
          pname = '关联属性';
          break;
        case 11:
          pname = '其他属性';
          break;
        default:
          pname = '事件属性';
          break;
      }
      return pname;
    },

    propertyArrJiaoJi(arrArr) {
      const retArr = [];
      const len = arrArr.length;
      arrArr.forEach(arr => {
        arr.forEach(item => {
          const findItem = retArr.find(i => i.propertyName === item.propertyName);
          if (findItem) {
            findItem.count += 1;
          } else {
            retArr.push({
              ...item,
              count: 1,
            });
          }
        });
      });
      return retArr.filter(item => item.count === len);
    },
  },
};
</script>

<style lang="less" scoped>
.select-props-container {
  .ref-cont {
    .text {
      font-size: 12px;
      &.empty {
        color: #bbb;
      }
    }
  }
  .ref-conts {
    min-width: 100px;
    border: 1px solid #dddddd;
    box-sizing: border-box;
    background-color: #fff;

    ::v-deep .t-button__text {
      display: flex;
      align-items: center;
    }
    .text {
      display: inline-block;
      width: 50px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: rgba(0, 0, 0, 0.9);
    }
    .icon {
      color: rgba(0, 0, 0, 0.4);
      margin-left: 10px;
      transition: all 0.5s;
    }
  }
}
.select-props-popover-container {
  .group {
    margin-top: 8px;
    margin-bottom: 8px;
    //padding: 0 10px 0 10px;
    overflow: auto;
    .btn {
      cursor: pointer;
      color: #606266;
      background-color: #fff;
      margin: 4px 10px 0 0;
      //padding: 6px 8px;
      &:last-child {
        margin-right: 0;
      }
      &.active {
        color: white;
        background-color: #5a66ff;
      }
    }
  }

  .content {
    max-height: 250px;
    overflow: auto;
    line-height: 2.6rem;
    //padding: 2px 10px 10px 10px;
    .total {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 10px;
      padding-right: 10px;
      &.is-disabled {
        color: #c0c4cc;
        cursor: not-allowed;
      }
      &:hover {
        background-color: rgb(245, 247, 250);
      }
    }

    .group-item {
      .header {
        display: flex;
        align-items: center;
        padding-left: 10px;
        padding-right: 10px;
        .txt {
          color: #5a66ff;
        }

        .line {
          flex: 1;
          margin-left: 10px;
          border-bottom: 1px dashed grey;
          height: 1px;
        }
      }

      .list {
        .list-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-left: 10px;
          padding-right: 10px;
          &.is-disabled {
            color: #c0c4cc;
            cursor: not-allowed;
          }
          &:hover {
            background-color: rgb(245, 247, 250);
          }
          .label {
            //font-size: 12px;
          }
          .val {
            max-width: 40%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: rgb(132, 146, 166);
            //font-size: 10px;
          }
        }
      }
    }
  }

  .empty {
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    .info {
      .desc {
        color: grey;
        opacity: 0.5;
      }
    }
  }
}
</style>
